import { render, staticRenderFns } from "./ReleaseDetails.vue?vue&type=template&id=19c8727d&scoped=true"
import script from "./ReleaseDetails.vue?vue&type=script&lang=ts"
export * from "./ReleaseDetails.vue?vue&type=script&lang=ts"
import style0 from "./ReleaseDetails.vue?vue&type=style&index=0&id=19c8727d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c8727d",
  null
  
)

export default component.exports